import {
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import { Component } from 'react';
import  {all_information, loadingShow } from '../../../App';
import Message from '../../../utils/Message/Message';
import {
  AddShiftWorkbenchSettings,
  DeleteShiftWorkbenchSettings,
  EditShiftWorkbenchSettings,
  getShiftWorkbenchSettings,
} from '../../../services/ShiftWorkbench/ShitWorkbenchSettingsServices';
interface IState {
  visibleAddDialog: boolean;
  visibleEditDialog: boolean;
  visibleDeleteDialog: boolean;
  truckFactorData: any;
}
interface IProps {
  GridHeight?: any;
}
export class MovementsType extends Component<IProps, IState> {
  private securityRoleGrid: GridComponent;
  private movementsId: number = -1;
  private isAdd: boolean = true;
  private title: string = '';
  private caseSep = 'movementstype';
  public validationRule: Object = { required: true };
  constructor(props: IProps) {
    super(props);
    this.securityRoleGrid = new GridComponent(props);
    this.state = {
      visibleAddDialog: false,
      visibleEditDialog: false,
      visibleDeleteDialog: false,
      truckFactorData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-repeat',
      id: 'refresh-m',
    },
    'ExcelExport',
    'ColumnChooser',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
    allowEditOnDblClick: true,
    showDeleteConfirmDialog: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  deleteMovements() {
    const obj = {
      id: this.movementsId,
    };
    DeleteShiftWorkbenchSettings(obj)
      .then((res) => {
        loadingShow(false);
        Message.success('Successfully');
        this.getTruckFactor(this.caseSep);
        this.setState({ visibleDeleteDialog: false });
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  addMovements(objCommer: any) {
    const obj = {
      app: 'UWORK',
      user_id: all_information.user_id,
      organization_id: all_information.company_id?.toString(),
      m_type_description: objCommer.m_type_description,
      m_type_code: objCommer.m_type_code,
      id: objCommer.id,
      type: this.caseSep,
    };

    if (this.isAdd) {
      delete obj.id;
      AddShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);
          Message.success('Successfully');
          this.getTruckFactor(this.caseSep);
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      EditShiftWorkbenchSettings(obj)
        .then((res) => {
          loadingShow(false);

          Message.success('Successfully');
          this.getTruckFactor(this.caseSep);
          this.setState({ visibleAddDialog: false });
        })
        .catch((err) => {
          loadingShow(false);
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  }
  componentDidMount() {
    this.getTruckFactor(this.caseSep);
  }

  getTruckFactor(caseSep: string) {
    getShiftWorkbenchSettings(caseSep)
      .then((el) => {
        this.setState({ truckFactorData: el.data });
      })
      .catch((e) => {
        //(e);
      });
  }
  actionBegin(args: any) {
    if (args.requestType === 'refresh-m') {
      this.getTruckFactor(this.caseSep);
    }
    if (args.action === 'add') {
      this.isAdd = true;
      this.addMovements(args.data);
    } else if (args.action === 'edit') {
      this.isAdd = false;
      this.addMovements(args.data);
    } else if (args.requestType === 'delete') {
      this.movementsId = args.data[0].id;
      this.deleteMovements();
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridShiftworkbenchMovementsType'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.truckFactorData}
          height='65vh'
          ref={(theGrid: GridComponent) => (this.securityRoleGrid = theGrid)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          actionBegin={this.actionBegin.bind(this)}
          allowResizing={true}
          enablePersistence
          allowExcelExport
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='m_type_code'
              headerText='Movements Type Code'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='m_type_description'
              headerText='Movements Type Description'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              ColumnChooser,
              ExcelExport,
              Page,
              ColumnMenu,
              Resize,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default MovementsType;
